import { Button, Stack } from '@mui/material';
import React from 'react';
import ButtonLoading from '../../../../components/ButtonLoading';
import config from '../../../../constants/config';
import { JobT } from '../../../../types/Job';
import { AxiosInstance } from '../../../../utils/RequestMethods';

export type IGenerateDisputeRebuttalTabProps = {
    job: JobT
}

const GenerateDisputeRebuttalTab: React.FC<IGenerateDisputeRebuttalTabProps> = (props) => {
    const [urlDispute, setUrlDispute] = React.useState("");

    React.useEffect(() => {
        setUrlDispute(props?.job?.disputeLink)
    }, []);
    // const urlDispute = props?.job?.disputeLink

    return (
        <Stack p={2} >
            {!urlDispute ? <ButtonLoading
                style={{
                    maxWidth: 300
                }}
                // noShowResultMessage
                variant='light'
                // noShowResultMessageSuccess
                // noShowResultMessageError
                timeShowMsg={100}
                onClickFetching={async (event): Promise<string> => {
                    // if (urlDispute) {
                    //     navigator.clipboard.writeText(urlDispute);
                    //     return "Dispute link copied."
                    // }
                    return await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/dispute/create_token`).then((res) => {
                        if (res?.data) {
                            // let url = `${window.location.host}/job/${props?.job?.id}/dispute/${res?.data?.token}`
                            setUrlDispute(res?.data?.dispute_link)
                            // navigator.clipboard.writeText(res?.data?.dispute_link);
                            return "Dispute link generated."
                        }
                    })
                }}>Generate dispute link</ButtonLoading>
                : <Button style={{ maxWidth: 300 }} variant='outlined' target={"_blank"} href={urlDispute}>
                    Open dispute page
                </Button>}
        </Stack >
    );
}

export default GenerateDisputeRebuttalTab
